<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AppTabbar from './components/layout/AppTabbar.vue'
import { ROUTE_META, ROUTE_PATHS } from './constants'
import { useAppStore } from './stores/app'
import { useThemeStore } from './stores/theme'

const route = useRoute()
const appStore = useAppStore()
const themeStore = useThemeStore()

/** Tab 页用 keep-alive 缓存，避免切 tab 丢滚动位置 / 重复拉数 */
const tabKeepAliveIncludes = [
  ROUTE_PATHS.home,
  ROUTE_PATHS.device,
  ROUTE_PATHS.profile,
].map(path => {
  // 与动态 import 组件名对齐：HomePage / DevicePage / ProfilePage
  if (path.includes('device'))
    return 'DevicePage'
  if (path.includes('profile'))
    return 'ProfilePage'
  return 'HomePage'
})

const transitionName = computed(() => {
  if (route.meta[ROUTE_META.tab] || route.meta[ROUTE_META.plain])
    return 'fade'
  return 'page-slide'
})

onMounted(() => {
  themeStore.initTheme()
  void appStore.bootstrap()
})
</script>

<template>
  <van-config-provider :theme="themeStore.isDark ? 'dark' : 'light'">
    <main class="app-root">
      <router-view v-slot="{ Component, route: currentRoute }">
        <transition :name="transitionName" mode="out-in">
          <keep-alive :include="tabKeepAliveIncludes">
            <component :is="Component" :key="currentRoute.meta[ROUTE_META.tab] ? currentRoute.path : currentRoute.fullPath" />
          </keep-alive>
        </transition>
      </router-view>
      <AppTabbar />
    </main>
  </van-config-provider>
</template>

<style>
.page-slide-enter-active,
.page-slide-leave-active {
  transition: opacity .18s ease, transform .18s ease;
}
.page-slide-enter-from {
  opacity: 0;
  transform: translate3d(12px, 0, 0);
}
.page-slide-leave-to {
  opacity: 0;
  transform: translate3d(-8px, 0, 0);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .12s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
